module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/quick_easy--xxl@2x-f636c4f1d69e3b87523b6a23028d09a9.png";